import { Dispatch } from 'redux';
import { LoadBillingAndShipping, ProfileDispatchTypes, ProfileTypes } from './Types';
import { ApiEndpoints, ActionHandler } from 'Utils';

export const GetProfile = () => (dispatch: Dispatch<ProfileDispatchTypes>) => {
	dispatch({ type: ProfileTypes.LOADING_PROFILE });
	return ActionHandler(
		{ url: ApiEndpoints.profile, method: 'GET', dispatch },
		res => {
			const { user } = res.data;

			dispatch({ type: ProfileTypes.LOAD_PROFILE_SUCCESS, payload: user });
		},
		error => {
			dispatch({ type: ProfileTypes.PROFILE_FAIL, error });
		},
	);
};

export const updateWelcome = () => (dispatch: Dispatch<ProfileDispatchTypes>) => {
	return ActionHandler(
		{ url: ApiEndpoints.activateWelcome, method: 'PUT', dispatch },
		res => {
			dispatch({ type: ProfileTypes.ACTIVATE_WELCOME });
		},
		error => {
			dispatch({ type: ProfileTypes.PROFILE_FAIL, error });
		},
	);
};

export const forgetPassword = (email: string) => (dispatch: Dispatch<ProfileDispatchTypes>) => {
	const data = JSON.stringify({ email });
	return ActionHandler(
		{ url: ApiEndpoints.forgotPassword, method: 'POST', dispatch, data },
		res => {
			const { message } = res.data;

			dispatch({ type: ProfileTypes.FORGOT_PASSWORD, payload: { message } });
		},
		error => {
			dispatch({ type: ProfileTypes.PROFILE_FAIL, error });
		},
	);
};

export const resetPasswordfun =
	(currentPassword: string, newPassword: string) => (dispatch: Dispatch<ProfileDispatchTypes>) => {
		const data = JSON.stringify({ currentPassword, newPassword });
		return ActionHandler(
			{ url: ApiEndpoints.resetPassword, method: 'PUT', dispatch, data },
			res => {
				const { data } = res;

				dispatch({ type: ProfileTypes.PROFILE_PASSWORD_RESET });
			},
			error => {
				dispatch({ type: ProfileTypes.PROFILE_FAIL, error });
			},
		);
	};

export const newPasswordfun =
	(newPassword: string, token: string) => (dispatch: Dispatch<ProfileDispatchTypes>) => {
		const data = JSON.stringify({ newPassword, token });
		return ActionHandler(
			{ url: ApiEndpoints.newPassword, method: 'PUT', dispatch, data },
			res => {
				const { data } = res;

				dispatch({ type: ProfileTypes.PROFILE_PASSWORD_RESET });
			},
			error => {
				dispatch({ type: ProfileTypes.PROFILE_FAIL, error });
			},
		);
	};

export const activateEmail = (token: string) => (dispatch: Dispatch<ProfileDispatchTypes>) => {
	const newUrl = ApiEndpoints.activateEmail + `/${token}`;
	return ActionHandler(
		{ url: newUrl, method: 'GET', dispatch },
		res => {
			const { data } = res;

			dispatch({ type: ProfileTypes.PROFILE_PASSWORD_RESET });
		},
		error => {
			dispatch({ type: ProfileTypes.PROFILE_FAIL, error });
		},
	);
};

export const billingAndShippingUpdate =
	({
		city,
		address,
		state,
		zipCode,
		phoneNumber,
		shipping_phoneNumber,
		shipping_zipCode,
		shipping_city,
		shipping_state,
		shipping_address,
		isSameAddress,
		fullName,
	}: LoadBillingAndShipping) =>
	(dispatch: Dispatch<ProfileDispatchTypes>) => {
		const data = JSON.stringify({
			address,
			city,
			zipCode,
			state,
			phoneNumber,
			// business address
			shipping_address,
			shipping_city,
			shipping_zipCode,
			shipping_state,
			shipping_phoneNumber,
			isSameAddress,
			fullName,
		});
		return ActionHandler(
			{ url: ApiEndpoints.profile, method: 'PUT', dispatch, data },
			res => {
				const { data } = res;

				dispatch({ type: ProfileTypes.UPDATE_BILLING_AND_SHIPPING });
			},
			error => {
				dispatch({ type: ProfileTypes.UPDATE_BILLING_AND_SHIPPING_FAIL, error });
			},
		);
	};

export const GetAddress = () => (dispatch: Dispatch<ProfileDispatchTypes>) => {
	dispatch({ type: ProfileTypes.LOADING_PROFILE });
	return ActionHandler(
		{ url: ApiEndpoints.billing, method: 'GET', dispatch },
		res => {
			const { data } = res.data;

			dispatch({ type: ProfileTypes.LOAD_BILLING_AND_SHIPPING, payload: data });
		},
		error => {
			dispatch({ type: ProfileTypes.PROFILE_FAIL, error });
		},
	);
};

export const GetAllKids = () => (dispatch: Dispatch<ProfileDispatchTypes>) => {
	dispatch({ type: ProfileTypes.LOADING_PROFILE });
	return ActionHandler(
		{ url: ApiEndpoints.getAllKids, method: 'GET', dispatch },
		res => {
			const { data } = res.data;
			dispatch({ type: ProfileTypes.LOAD_ALL_KIDS, payload: data });
		},
		error => {
			dispatch({ type: ProfileTypes.PROFILE_FAIL, error });
		},
	);
};

export const clearAddress = () => (dispatch: Dispatch<ProfileDispatchTypes>) => {
	dispatch({ type: ProfileTypes.LOADING_PROFILE });
	return ActionHandler(
		{ url: ApiEndpoints.billing, method: 'GET', dispatch },
		res => {
			const { data } = res.data;

			dispatch({ type: ProfileTypes.CLEAR_ADDRESS });
		},
		error => {
			dispatch({ type: ProfileTypes.PROFILE_FAIL, error });
		},
	);
};
